export enum DepartmentProcess {
  Print = 0,
  Foil = 1,
  OtherHandle = 2,
  Shape = 3,
  Cut = 4,
  Paste = 5,
  Package = 6,
}
